export default __webpack_public_path__ + "static/media/filter_icon_dining_area.ea942919.svg";